import * as React from 'react';

//hook
import { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';

//mui
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogProps } from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';

//mui icon
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import ReplayIcon from '@mui/icons-material/Replay';


//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//api
import { GetBarndListApi } from '../api/brandList/GetBarndListApi';
import { UpdateCarApi } from '../api/Host/UpdateCarApi';
import { PostAddCarApi } from '../api/Host/PostAddCarApi';
import { GetCategoryListApi } from '../api/category/GetCategoryListApi';
import { GetCarBrandModelListApi } from '../api/brandList/GetCarBrandModelListApi';



//type
import { addCarReqType, CarImage } from '../api/Host/type/AddCarType';
import AddImagesWithTitle from '../component/addAndDeleteImages/AddImagesWithTitle';

//utils
import { convertUrlToFile } from '../utils/convertUrlToFile';

interface addCarProps {
    selectedCar?: any | null
    setSelectedCar?: (selectedDriver?: any) => void
    openAddCar: {open:boolean,scrollType: DialogProps['scroll']}
    setOpenAddCar: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void
    setMyCars:(element: any[]) => void
    getMyCars: () => Promise<any>
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const names = ["petrol", "diesel", "electric", "hybrid"];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;


const AddCar = ({selectedCar, setSelectedCar, openAddCar, setOpenAddCar, setMyCars, getMyCars}: addCarProps) => {
    const {t} = useTranslation();
    const {
        loading: brandLoading,
        error: brandError,
        HandlerApi: getBrand
    } = useApi(GetBarndListApi, "GET")
    const {
        loading: carBrandModelLoading,
        error: carBrandModelError,
        HandlerApi: getCarBrandModelModel
    } = useApi(GetCarBrandModelListApi, "GET")
    const {
        loading: categoryLoading,
        error: categoryError,
        HandlerApi: getCategory
    } = useApi(GetCategoryListApi, "GET")
    const {
        loading: updateCarLoading,
        error: updateCarError,
        HandlerApi: updateCar
    } = useApi(UpdateCarApi, "Post")
    let {
        loading: addCarLoading, 
        error: addCarError, 
        HandlerApi: postAddCar
       } = useApi(PostAddCarApi, "Post")

    let [brandList, setBrandList] = useState<any[]>([]);
    let [carBrandModelList, setCarBrandModelList] = useState<any[]>([]);
    let [categoryList, setcategoryList] = useState<any[]>([]);
    const [frontMechanic, setFrontMechanic] = useState<string>('')
    const [backMechanic, setBackMechanic] = useState<string>('')
    const [deleteImageIds, setDeleteImageIds] = useState<number[]>([]);
    const [imagePreviews, setImagePreviews] = useState<(string | null)[]>([]);
    const carSchema = Yup.object().shape({
        brand_name_id: Yup.number().required(t("please_select_a_brand")),
        car_model_id: Yup.number().required(t("model_required")),
        category_id: Yup.number().required(t("please_select_a_category")),
        year_of_manufacture: Yup.number()
        .required(t("year_of_manufacture_required"))
        .test("model", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
        plate_number:Yup.number()
        .required(t("plate_number"))
        .test("plate_number", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
        fuel_type: Yup.string().required(t("fuel_type_required")),
        seating_capacity: Yup.number()
        .required(t("seating_capacity"))
        .test("seating_capacity", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
        // الحقول الشرطية للأسعار
        daily_price: Yup.number().when("is_daily", {
            is: 1,
            then: schema => schema.required(t("daily_price_required")).moreThan(0, t("the_number_must_be_greater_than_zero")),
            otherwise: schema => schema.notRequired()
        }),
        weekly_price: Yup.number().when("is_weekly", {
            is: 1,
            then: schema => schema.required(t("weekly_price_required")).moreThan(0, t("the_number_must_be_greater_than_zero")),
            otherwise: schema => schema.notRequired()
        }),
        monthly_price: Yup.number().when("is_monthly", {
            is: 1,
            then: schema => schema.required(t("monthly_price_required")).moreThan(0, t("the_number_must_be_greater_than_zero")),
            otherwise: schema => schema.notRequired()
        }),

        test: Yup.string().test(
        "test",
        t("you_must_select_at_least_one_price"),
        function() {
            const { is_daily, is_weekly, is_monthly } = this.parent;
            if (is_daily === 0 && is_weekly === 0 && is_monthly === 0) {
                return false
            }
            return true;
        }
        ),
        front_mechanic_image_url: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        background_mechanic_image_url: Yup.mixed()
            .required(t("back_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        images: Yup.array()
        .of(
            Yup.object({
            file: Yup.mixed()
                .required(t("image_file_required")),
            title: Yup.string()
                .required(t("image_title_required")),
            })
        )
        .min(1, t("you_must_add_at_least_one_image"))
    })

    useEffect(() => {
        const fetchData = async () => {
            const result = await getCategory();
            setcategoryList(result.data);
            getBrand().then((res) => {
                setBrandList(res.data);
            })
            .catch(() => {});
            brandList.length > 0 || selectedCar && getCarBrandModelModel(selectedCar?.brand_name_id).then((res) => {
                setCarBrandModelList(res.data);
            })
            .catch(() => {});
        }
        fetchData();
    },[])

    //start functions
    
    const handleCloseDilaog = () => {
        setOpenAddCar({open: false, scrollType: 'paper'})
        setSelectedCar?.(undefined)
        setFrontMechanic('');
        setBackMechanic('');
        setImagePreviews([]);
        setDeleteImageIds([]);
    }
    const handleSubmit = async (values: addCarReqType) => {
        let payload: any = { ...values };
        delete payload.test
        if(values.is_daily === 0) {
            delete payload.daily_price
        }
        if (values.is_weekly === 0) {
            delete payload.weekly_price
        }
        if (values.is_monthly === 0) {
            delete payload.monthly_price
        }
        if(selectedCar) {
            if ('front_mechanic_image_url' in payload && typeof payload.front_mechanic_image_url === "string") {
                payload.front_mechanic_image_url = await convertUrlToFile(payload.front_mechanic_image_url);
            }
            if ('background_mechanic_image_url' in payload && typeof payload.background_mechanic_image_url === "string") {
                payload.background_mechanic_image_url = await convertUrlToFile(payload.background_mechanic_image_url);
            }
            deleteImageIds.forEach((id, index) => {
                payload[`delete_image_ids[${index}]`] = id;
            });
            
            payload.images.map((image: any) => {
                delete image.id;
            });
            if (payload.images && Array.isArray(payload.images)) {
                payload.images = payload.images.filter((img: any) => img.file && typeof img.file !== "string");
            }
            let result = await updateCar(payload, selectedCar.id);
            if(result.code === 200) {
                setOpenAddCar({open: false, scrollType: 'paper'})
                let result = await getMyCars();
                setMyCars(result.data)
                setSelectedCar?.(undefined)
                setFrontMechanic('');
                setBackMechanic('');
                setImagePreviews([]);
                setDeleteImageIds([]);
            }
        }
        else {
            let result = await postAddCar(payload);
            if(result.code === 200) {
                setOpenAddCar({open: false, scrollType: 'paper'})
                let result = await getMyCars();
                setMyCars(result.data)
                setSelectedCar?.(undefined)
                setFrontMechanic('');
                setBackMechanic('');
                setImagePreviews([]);
                setDeleteImageIds([]);
            }
        }
    }

    //end functions

  return (
    <Dialog 
    open={openAddCar.open}
    onClose={handleCloseDilaog}
    slots={{
    transition: Transition,
    }}
    disableRestoreFocus
    maxWidth="sm"
    fullWidth 
    >
        <div style={{padding: "16px 24px 0px"}} className={`flex justify-between items-center`}>
            <DialogTitle className='!p-0'>
                {
                    selectedCar
                    ?<p>{t("edit_car") }</p>
                    :<p>{t(`add_new_car`)}</p>
                }
            </DialogTitle>
            <IconButton
            className={`!bg-paretnerColor !rounded-md max-sm:!w-[30px] max-sm:!h-[30px]`}
            onClick={() => {
                setOpenAddCar({open: false, scrollType: "paper"});
                setSelectedCar?.(undefined)
            }}
            size="large"
            >
                <CloseIcon className='!text-white'/>
            </IconButton>
        </div>
        <DialogContent>
            <Formik
            enableReinitialize
            initialValues={{
                brand_name_id: selectedCar?.brand_name_id ?? "",
                car_model_id: selectedCar?.model?.id || "",
                category_id: selectedCar?.category_id || null,
                year_of_manufacture: selectedCar?.year_of_manufacture || null,
                plate_number: selectedCar?.plate_number || null,
                color: selectedCar?.color || "FFFFFF",
                fuel_type: selectedCar?.fuel_type || "",
                seating_capacity: selectedCar?.seating_capacity || null,
                is_daily: selectedCar?.is_daily || 0,
                daily_price: selectedCar?.daily_price || null,
                is_weekly: selectedCar?.is_weekly || 0,
                weekly_price: selectedCar?.weekly_price || null,
                is_monthly: selectedCar?.is_monthly || 0,
                monthly_price: selectedCar?.monthly_price || null,
                has_driver:selectedCar?.has_driver || 0,
                test: "",
                front_mechanic_image_url: selectedCar?.front_mechanic_image_url || null,
                background_mechanic_image_url: selectedCar?.background_mechanic_image_url || null,
                images: selectedCar?.primary_images
                    ? selectedCar.primary_images.map((img: CarImage) => ({
                        id: img.id,
                        file: img.url,
                        title: img.title,
                    }))
                    : [],
            }}
            validationSchema={carSchema}
            onSubmit={(values)=>handleSubmit(values)}
            >
            {({values,touched, errors,setFieldValue, setFieldTouched}) => (
                <Form>
                    <div className='flex max-sm:flex-col gap-2'>
                        <FormControl className='sm:!w-1/2 !w-full' error={touched.brand_name_id && Boolean(errors.brand_name_id)}>
                            <InputLabel>{t("brand_name")}</InputLabel>
                            <Select
                            input={<OutlinedInput label={t("brand_name")} />}
                            MenuProps={MenuProps}
                            value={values.brand_name_id || ""}
                            onChange={async (e) => {
                                setFieldValue("brand_name_id", e.target.value)
                                const result = await getCarBrandModelModel(e.target.value)
                                setCarBrandModelList(result.data)
                            }}
                            >
                            {
                                brandLoading 
                                ?
                                    <div className="flex justify-center items-center gap-2">
                                        <CircularProgress size={18} />
                                    </div>
                                :
                                brandError 
                                    ?
                                        <div className=" cursor-pointer flex justify-center mt-4">
                                            <ReplayIcon onClick={()=>{getBrand()}} className='!text-[25px]'/>
                                        </div>
                                    :
                                        brandList.map((item: any) => (
                                            <MenuItem key={item.id} value={item.id}>
                                            {item.name}
                                            </MenuItem>
                                        ))}
                            </Select>
                            {touched.brand_name_id && errors.brand_name_id && (
                                <p className="text-red-500 text-xs mt-1">
                                {errors.brand_name_id as string}
                                </p>
                            )}
                        </FormControl>
                        <FormControl className='sm:!w-1/2 !w-full' error={touched.car_model_id && Boolean(errors.car_model_id)}>
                            <InputLabel>{t("model")}</InputLabel>
                            <Select
                            input={<OutlinedInput label={t("model")} />}
                            MenuProps={MenuProps}
                            value={values.car_model_id || ""}
                            onChange={(e) => setFieldValue("car_model_id", e.target.value)}
                            >
                                {
                                    values.brand_name_id 
                                    ?
                                        carBrandModelLoading 
                                        ?
                                            <div className="flex justify-center items-center gap-2">
                                                <CircularProgress size={18} />
                                            </div>
                                        :
                                        carBrandModelError
                                            ?
                                                <div className=" cursor-pointer flex justify-center mt-4">
                                                    <ReplayIcon onClick={()=>{getBrand()}} className='!text-[25px]'/>
                                                </div>
                                            :
                                                carBrandModelList.map((item: any) => (
                                                    <MenuItem key={item.id} value={item.id}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))
                                    : <p>{t("please_select_brand_first")}</p>
                                }
                            </Select>
                            {touched.car_model_id && errors.car_model_id && (
                                <p className="text-red-500 text-xs mt-1">
                                {errors.car_model_id as string}
                                </p>
                            )}
                        </FormControl>
                    </div>
                    <div className='mt-5 flex max-sm:flex-col gap-2'>
                        <FormControl className='sm:!w-1/2 !w-full' error={touched.category_id && Boolean(errors.category_id)}>
                            <InputLabel>{t("category")}</InputLabel>
                            <Select
                            input={<OutlinedInput label={t("category")} />}
                            MenuProps={MenuProps}
                            value={values.category_id}
                            onChange={(e) => setFieldValue("category_id", e.target.value)}
                            >
                            {
                                categoryLoading
                                ?
                                    <div className="flex justify-center items-center gap-2">
                                        <CircularProgress size={18} />
                                    </div>
                                :
                                categoryError
                                    ?
                                        <div className=" cursor-pointer flex justify-center mt-4">
                                            <ReplayIcon onClick={()=>{getCategory()}} className='!text-[25px]'/>
                                        </div>
                                    :
                                        categoryList.map((item: any) => (
                                            <MenuItem key={item.id} value={item.id}>
                                            {item.name}
                                            </MenuItem>
                                        ))}
                            </Select>
                            {touched.category_id && errors.category_id && (
                                <p className="text-red-500 text-xs mt-1">
                                {errors.category_id as string}
                                </p>
                            )}
                        </FormControl>
                        <Field
                        as={TextField}
                        name="year_of_manufacture"
                        type="text"
                        label={t("year_of_manufacture")}
                        helperText={touched.year_of_manufacture && errors.year_of_manufacture ? errors.year_of_manufacture : ""}
                        error={touched.year_of_manufacture && Boolean(errors.year_of_manufacture)}
                        className="sm:w-1/2 w-full"
                        />
                    </div>
                    <div className='mt-5 flex max-sm:flex-col gap-2'>
                        <div className="sm:w-1/2 w-full">
                            <Field
                            as={TextField}
                            name="plate_number"
                            type="number"
                            label={t("plate_number")}
                            helperText={touched.plate_number && errors.plate_number ? errors.plate_number : ""}
                            error={touched.plate_number && Boolean(errors.plate_number)}
                            className="w-full"
                            />
                        </div>
                        <div className="sm:w-1/2 w-full">
                            <Field
                                as={TextField}
                                name="color"
                                type="color"
                                label={t("color")}
                                className="w-full"
                            />               
                        </div>
                    </div>
                    <div className='mt-5 flex max-sm:flex-col gap-2'>
                        <FormControl className='sm:!w-1/2 !w-full' error={touched.brand_name_id && Boolean(errors.brand_name_id)}>
                            <InputLabel>{t("engine_type")}</InputLabel>
                            <Select
                            input={<OutlinedInput label={t("engine_type")} />}
                            MenuProps={MenuProps}
                            value={values.fuel_type}
                            onChange={(e)=>setFieldValue("fuel_type", e.target.value)}
                            >
                            {names.map((name) => (
                                <MenuItem key={name} value={name}>{t(name)}</MenuItem>
                            ))}
                            </Select>
                           {touched.fuel_type && errors.fuel_type && (
                                <p className="text-red-500 text-xs mt-1">
                                {errors.fuel_type as string}
                                </p>
                            )}
                        </FormControl>
                        <Field
                            as={TextField}
                            label={t("seating_capacity")}
                            variant="outlined"
                            type='number'
                            name="seating_capacity"
                            helperText={touched.seating_capacity && errors.seating_capacity ? errors.seating_capacity : ""}
                            error={touched.seating_capacity && Boolean(errors.seating_capacity)}
                            className="sm:w-1/2 w-full"
                        />
                    </div>
                    <div className='flex flex-wrap gap-2'>
                        <FormControlLabel control={<Checkbox checked={values.is_daily === 1 ? true : false} onChange={(e) => setFieldValue("is_daily", e.target.checked ? 1 : 0)}  />} label={t("is_daily")} />
                        {
                        values.is_daily === 1 ?
                        <Field
                        as={TextField}
                        label={t("daily_price")}
                        variant="outlined" 
                        type='number'
                        name="daily_price"
                        helperText={touched.daily_price && errors.daily_price ? errors.daily_price : ""}
                        error={touched.daily_price && Boolean(errors.daily_price)}
                        className='w-full mb-2' 
                        />
                        : null
                        }
                    </div>
                    <div className='flex flex-wrap gap-2'>
                        <FormControlLabel control={<Checkbox checked={values.is_weekly === 1 ? true : false}  onChange={(e) => setFieldValue("is_weekly", e.target.checked ? 1 : 0)} />} label={t("is_weekly")} />
                        {
                        values.is_weekly === 1 ?
                        <Field
                        as={TextField}
                        label={t("weekly_price")} 
                        variant="outlined" 
                        type='number'
                        name="weekly_price" 
                        helperText={touched.weekly_price && errors.weekly_price ? errors.weekly_price : ""}
                        error={touched.weekly_price && Boolean(errors.weekly_price)}
                        className='w-full mb-2' 
                        />
                        : null
                        }
                    </div>
                    <div className='flex flex-wrap gap-2'>
                        <FormControlLabel control={<Checkbox checked={values.is_monthly === 1 ? true : false} onChange={(e) => setFieldValue("is_monthly", e.target.checked ? 1 : 0)} />} label={t("is_monthly")} />                   {
                        values.is_monthly === 1 ?
                        <Field
                        as={TextField}
                        label={t("monthly_price")} 
                        variant="outlined" 
                        type='number'
                        name="monthly_price" 
                        helperText={touched.monthly_price && errors.monthly_price ? errors.monthly_price : ""}
                        error={touched.monthly_price && Boolean(errors.monthly_price)}
                        className='w-full mb-2' 
                        />
                        : null
                        }                    
                    </div>
                    <div>
                        <Field
                        as={TextField}
                        label={t("test")} 
                        variant="outlined"
                        type='text'
                        name="test" 
                        helperText={touched.test && errors.test ? errors.test : ""}
                        error={touched.test && Boolean(errors.test)}
                        className='w-full mb-2 !hidden' 
                        />
                        <p className="text-[12px] mt-2 text-red-500">
                            {touched.test && errors.test ? errors.test : ""}
                        </p>
                    </div>
                    {/* <div className='flex flex-wrap gap-2'>
                        <FormControlLabel 
                        control={
                            <Checkbox 
                            checked={values.has_driver === 1 ? true : false}
                            onChange={(e) => setFieldValue("has_driver", e.target.checked === true ? 1 : 0)}
                            />
                        } 
                        label={t("the_car_has_a_driver")}
                        />
                    </div> */}
                    <div>
                        <DialogTitle className='!px-0'>
                            <p>{t("upload_mechanic_photo")}</p>
                        </DialogTitle>
                        <div className="flex max-sm:flex-col max-sm:items-center gap-5">
                            <div>
                                <Button
                                    component="label"
                                    className='!bg-paretnerColor !text-white !text-[11px] w-fit !capitalize'
                                    startIcon={<CloudUploadIcon />}
                                >
                                    {t("front_mechanic_image")}
                                    <VisuallyHiddenInput
                                    type="file"
                                    accept="image/*"
                                    onChange={(event) => {
                                        const file = event.target.files?.[0];
                                        if (file) {
                                        setFieldValue("front_mechanic_image_url", file);
                                        setFrontMechanic(URL.createObjectURL(file));
                                        }
                                    }}
                                    />
                                </Button>

                                {frontMechanic
                                    ? (
                                        <img
                                        src={frontMechanic}
                                        alt="Front Mechanic Image"
                                        className="mt-3 w-40 h-28 object-cover rounded-lg border max-sm:mx-auto"
                                        loading="lazy"
                                        decoding="async"
                                        />
                                    )
                                    :selectedCar?.front_mechanic_image_url 
                                        ? (

                                            <img
                                            src={`${storageURL}/${selectedCar?.front_mechanic_image_url}`}
                                            alt="Front Mechanic Image"
                                            className="mt-3 w-40 h-28 object-cover rounded-lg border"
                                            loading="lazy"
                                            decoding="async"
                                            />
                                        ) 
                                        : null
                                }
                                <p className="text-[12px] mt-2 text-red-500">
                                    {touched.front_mechanic_image_url && errors.front_mechanic_image_url ? errors.front_mechanic_image_url.toString() : ""}
                                </p>
                            </div>
                            <div className="flex max-sm:flex-col max-sm:items-center gap-5">
                                <div>
                                    <Button
                                        component="label"
                                        className='!bg-paretnerColor !text-white !text-[11px] w-fit !capitalize'
                                        startIcon={<CloudUploadIcon />}
                                    >
                                        {t("back_mechanic_image")}
                                        <VisuallyHiddenInput
                                        type="file"
                                        accept="image/*"
                                        onChange={(event) => {
                                            const file = event.target.files?.[0];
                                            if (file) {
                                            setFieldValue("background_mechanic_image_url", file);
                                            setBackMechanic(URL.createObjectURL(file));
                                            }
                                        }}
                                        />
                                    </Button>

                                    {backMechanic
                                        ? (
                                            <img
                                            src={backMechanic}
                                            alt="Back Mechanic Image"
                                            className="mt-3 w-40 h-28 object-cover rounded-lg border max-sm:mx-auto"
                                            loading="lazy"
                                            decoding="async"
                                            />
                                        )
                                        :selectedCar?.background_mechanic_image_url 
                                            ? (
                                                <img
                                                src={`${storageURL}/${selectedCar?.background_mechanic_image_url}`}
                                                alt="Back Mechanic Image"
                                                className="mt-3 w-40 h-28 object-cover rounded-lg border"
                                                loading="lazy"
                                                decoding="async"
                                                />
                                            ) 
                                            : null
                                    }
                                    <p className="text-[12px] mt-2 text-red-500">
                                        {touched.background_mechanic_image_url && errors.background_mechanic_image_url ? errors.background_mechanic_image_url.toString() : ""}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AddImagesWithTitle
                        selectedCar={selectedCar}
                        deleteImageIds={deleteImageIds}
                        setDeleteImageIds={setDeleteImageIds}
                        imagePreviews={imagePreviews}
                        setImagePreviews={setImagePreviews}
                        storageURL={storageURL}
                    />
                    <hr className='mt-5'/>
                    <DialogActions className={i18n.language === "en" ? "!justify-start" : "!justify-start"}>
                        <Button className='w-full !bg-paretnerColor !text-white !rounded-full' type="submit">
                            {addCarLoading || updateCarLoading
                            ? <CircularProgress className='w-1 h-1'/>
                            :selectedCar ? t("update_car") :t("confirm")
                            }
                        </Button>
                    </DialogActions>
                </Form>
            )}
            </Formik>
        </DialogContent>
    </Dialog>
  )
}

export default AddCar